import { render, staticRenderFns } from "./JobPage.vue?vue&type=template&id=6f8601e2&scoped=true&"
import script from "./JobPage.vue?vue&type=script&lang=js&"
export * from "./JobPage.vue?vue&type=script&lang=js&"
import style0 from "./JobPage.vue?vue&type=style&index=0&id=6f8601e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8601e2",
  null
  
)

export default component.exports